import useTestId from '@ori/testid-generator';
import { TOP_BANNER_TITLE } from "./constants";
import { Title, TitleRoot } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Component for displaying title in TopBanner. For falsy value in `title` returns `null`.
 */
export var TopBannerTitle = function TopBannerTitle(_ref) {
  var title = _ref.title;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  if (!title) {
    return null;
  }
  return /*#__PURE__*/_jsx(TitleRoot, {
    "data-testid": getTestId(TOP_BANNER_TITLE),
    children: /*#__PURE__*/_jsx(Title, {
      children: title
    })
  });
};
//# sourceMappingURL=TopBannerTitle.js.map